// Reassign contiguous 0-based sequence numbers to a document list so the
// persisted order has no gaps (the UI shows No.1..N). Documents are sequenced
// per type, so call this per type array — never across mixed types.
export default function resequenceDocuments<T extends { sequenceNumber: number }>(documents: T[]): T[] {
  return documents.map((document, index) => ({ ...document, sequenceNumber: index }))
}
